import { RootState } from 'handlers';

export const getStudentLoanApplication = ({ studentLoanApplication }: RootState) => studentLoanApplication;
